export const getPaginationText = (componentCfg) => {
  const range01 = (componentCfg.page * componentCfg.limit) - componentCfg.limit + 1
  const range02 = componentCfg.page * componentCfg.limit

  return `${range01}-${range02 > componentCfg.total ? componentCfg.total : range02} of ${componentCfg.total} items`
}
